
// Components
import notfound_link_icon from '../assets/notfound-link.svg'

const ExpiredLinkPage = () => {
    return (
        <div style={{ textAlign: 'center', marginTop: '18px' }}>
            <img src={notfound_link_icon} alt=''/>
            <h3>Link Not Found</h3>
            <h5>The request link could not be found.</h5>
        </div>
    )
}

export default ExpiredLinkPage